import type { IconProps } from './IconProps';

export const CheckCircleFilledIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM10.8402 6.74933C11.0533 6.53632 11.0533 6.19096 10.8402 5.97794C10.6272 5.76493 10.2819 5.76493 10.0689 5.97794L7.18182 8.86497L5.93115 7.61431C5.71814 7.40129 5.37277 7.40129 5.15976 7.61431C4.94675 7.82732 4.94675 8.17268 5.15976 8.38569L6.79612 10.0221C7.00914 10.2351 7.3545 10.2351 7.56751 10.0221L10.8402 6.74933Z"
      fill="currentColor"
    />
  </svg>
);
